import React, {useEffect} from 'react';
import LazyBody from '@views/knowledge/components/LazyBody';
import DefaultLayout from '@src/components/_layouts/Default/DefaultLayout';
import {useDispatch} from 'react-redux';
import {articlesSetActiveId} from '@src/_redux/articles';

export default function IndexPage() {
    const dispatch = useDispatch();

    useEffect(() => void dispatch(articlesSetActiveId(null)), [dispatch]);

    return <DefaultLayout>
        <LazyBody pageTitle="Articles.index-page-title"/>
    </DefaultLayout>;
}
